import React from "react";
import DirectoryTable from "@/components/DirectoryTable";
import { useAuth } from "@/context/AuthContext";
import { hasRole } from "@/lib/utils";

const FIELDS = [
  { name: "name", label: "Faculty Name", required: true },
  { name: "email", label: "Email", type: "email" },
  { name: "phone", label: "Phone" },
  { name: "expertise_skill_ids", label: "Skills / Expertise", type: "skills_multiselect" },
  { name: "bio", label: "Bio / Notes", type: "textarea" },
];

const COLUMNS = [
  { key: "name", label: "Faculty Name" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  {
    key: "expertise_skill_ids",
    label: "Skills",
    render: (it, skills) => {
      const names = (it.expertise_skill_ids || []).map((id) => skills.find((s) => s.id === id)?.name).filter(Boolean);
      return names.length ? names.join(", ") : "-";
    },
  },
];

export default function AdminFaculty() {
  const { user } = useAuth();
  return (
    <DirectoryTable
      title="Faculty"
      description="Master list of faculty/trainers with their mapped skills. PM selects from this list on Step 2 and details auto-fill."
      endpoint="/faculty"
      columns={COLUMNS}
      fields={FIELDS}
      canWrite={hasRole(user, "pm")}
      canDelete={hasRole(user)}
      editable
    />
  );
}
